module.exports = __webpack_public_path__ + "img/06.eb9c51fc.jpg";